/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Query } from '@apollo/client/react/components';
import { bool, func, object } from 'prop-types';
import { useDispatch } from 'react-redux';
import mbpLogger from '@module-logger/mbp';
import MuiDialogContent from '@material-ui/core/DialogContent';
import {
    Dialog, DialogTitle, IconButton, Typography, DialogActions, makeStyles,
} from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import CloseIcon from '@material-ui/icons/Close';
import findContent from '../../../../../gql/queries/findContent';
import { GRAPHQL_ENV } from '../../../../../gql';
import { brandByCode } from '../helper';
import { setUserConfirmationForSubscriptionPopup } from '../../../../../../state/ducks/App/App-Actions';

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        fontSize: '.8em',
    },
    closeBtn: {
        position: 'absolute',
        top: '0',
        right: '0',
    },
    popUpHeading: {
        textAlign: 'center',
        '& span': {
            fontSize: '24px',
            [theme.breakpoints.down('md')]: {
                fontSize: '18px',
            },
        },
    },
    bottomContent: {
        margin: '0 auto',
        padding: '20px 0',
        fontSize: '20px',
        fontWeight: '600',
        color: theme.palette.black || '#000',
        textTransform: 'uppercase',
        textDecoration: 'underline',
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
}));

const SubscriptionTnC = ({ subscription, open, toggle }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const brand = brandByCode[subscription.brand] || '1800flowers';
    const findContentOptions = {
        brand,
        contentType: 'brand_configuration',
    };
    const GET_SUBSCRIPTION_INFORMATION = findContent(findContentOptions);
    return (
        <Query query={GET_SUBSCRIPTION_INFORMATION}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '82px' }} />;
                }
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (!data?.findContent?.content?.entries) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: GET_SUBSCRIPTION_INFORMATION,
                        component: ' SubscriptionInformation.js',
                        message: 'No product returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                const subscriptionInformation = <></>;

                const subscriptionData = {
                    terms: data.findContent?.content?.entries?.[0]?.other.subscription_terms || null,
                };

                if (subscriptionData.terms) {
                    return (
                        <>
                            <Dialog data-testid="subscription-terms-condition-modal" open={open}>
                                <DialogTitle className={classes.popUpHeading} id="customized-dialog-title">
                                    <span>Subscription Program Terms and Conditions</span>
                                    <IconButton className={classes.closeBtn} aria-label="Close" onClick={() => toggle(false)}>
                                        <CloseIcon />
                                    </IconButton>
                                </DialogTitle>
                                <MuiDialogContent className={classes.root}>
                                    <Typography gutterBottom className={classes.dialogContent}>
                                        <ReactMarkdown source={subscriptionData.terms} escapeHtml="false" />
                                    </Typography>
                                </MuiDialogContent>
                                <DialogActions>
                                    <IconButton id="accept-subscription-button" aria-label="close" className={classes.bottomContent} onClick={() => { dispatch(setUserConfirmationForSubscriptionPopup(true)); toggle(false); }}>
                                        <span>Close</span>
                                    </IconButton>
                                </DialogActions>
                            </Dialog>
                        </>
                    );
                }
                return subscriptionInformation;
            }}
        </Query>
    );
};

SubscriptionTnC.propTypes = {
    subscription: object.isRequired,
    open: bool.isRequired,
    toggle: func.isRequired,
};

export default SubscriptionTnC;
